
(function () {
    "use strict";

    headerLinks();

    // Wrap the translation and cart links in one wrapper to condense header size
    function headerLinks(){
        $(".lang-wrap, .cart-wrap").wrapAll('<div class="link-wrap"></div>');
    }
})();
